import { gql } from "@apollo/client";

export const SAVE_PARTNER_CONTACT_PERSON = gql`
  mutation savePartnerContactPerson($input: PartnerContactPersonInput!) {
    savePartnerContactPerson(input: $input) {
      quoteId
      contactInfoId
      contactPersons {
        webContactInfoId
        firstName
        lastName
        fullName
        phone
        email
        alternativeEMail
      }
    }
  }
`;

export const REMOVE_REQUIRED_DOCUMENT = gql`
  mutation removeRequiredDocument($quoteId: Int!, $sharePointUID: String!) {
    removeRequiredDocument(quoteId: $quoteId, sharePointUID: $sharePointUID)
  }
`;

export const UPLOAD_REQUIRED_DOCUMENT = gql`
  mutation uploadRequiredDocument(
    $quoteId: Int!
    $dmsContentType: String!
    $targetAreaCode: String
    $uploadedFiles: [Upload!]!
  ) {
    uploadRequiredDocument(
      quoteId: $quoteId
      dmsContentType: $dmsContentType
      targetAreaCode: $targetAreaCode
      uploadedFiles: $uploadedFiles
    ) {
      sharePointUID
      fileName
    }
  }
`;

export const UPLOAD_DEALER_DOCUMENT = gql`
  mutation uploadDealerDocument($quoteId: Int!, $documentId: Int!, $siteId: Int!, $uploadedFiles: [Upload!]!) {
    uploadDealerDocument(quoteId: $quoteId, documentId: $documentId, siteId: $siteId, uploadedFiles: $uploadedFiles) {
      sharePointUID
      fileName
    }
  }
`;

export const SEND_EMAIL_LINK = gql`
  mutation sendEmailLink($quoteId: Int!, $email: String) {
    sendEmailLink(quoteId: $quoteId, email: $email)
  }
`;
